
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topics/[urlname]",
      function () {
        return require("private-next-pages/topics/[urlname].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topics/[urlname]"])
      });
    }
  